import React from 'react'
import { Redirect } from 'react-router-dom';
import Dog from 'services/Dog';
import DogForm from 'components/DogForm';
import { Spinner } from 'components/atoms';

export default class DogCreate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      busy: false,
      item: new Dog(),
      itemId: null,
    }
    this.itemClass = Dog;
    this.itemsName = 'dogs'
  }

  itemChanged = (item) => {
    if (item && item.id) {
      this.setState({itemId: item.id});
    } else {
      this.setState({ item });
    }
  }

  onCancel = () => {
    this.props.history.goBack();
  }

  render() {
    const {item, itemId, busy} = this.state;
    let dogForm = null;
    if (itemId) {
      return <Redirect to={`/${this.itemsName}/${itemId}`} />
    }
    if (item) {
      dogForm = <DogForm item={item} onChange={this.itemChanged} onCancel={this.onCancel}/>;
    }
    return (
      <div className="container">
        <h4>Новая собака</h4>
        {dogForm}
        {busy && <Spinner /> }
      </div>
    );
  }

}